// اضافه کردن کتابخانه ها به صفحه
import * as React from "react"
import {createSearchParams, Link, NavLink, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {Https, KeyboardBackspace, PhoneIphone, Visibility, VisibilityOff} from '@mui/icons-material';
import {Box, Checkbox, CircularProgress, FormControlLabel, FormGroup} from '@mui/material';
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {setLoading} from "../../redux/loading/actions";
import {handleBorderColor, HandleValidationMethod, removeNonNumeric, useShowMessageComponent} from "../../assets/js/main";
import HandleFetchData from "../../plugin/HandleFetchData";
import {setValidations} from "../../redux/public/actions";


export default function Login() {
  // جابه جایی بین صفحات در متد ها
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const [searchParams] = useSearchParams();
  const {validationMethod} = HandleValidationMethod()

  // استفاده از متود های i18n برای چند زبان کردن پروژه و تغییر زبان پروژه
  const {t, i18n} = useTranslation()
  const {fetchData} = HandleFetchData()
  const divarIncomId = searchParams.get('state')
  const {showMessageComponent} = useShowMessageComponent()

  // متغیر و useState های لوکال صفحه
  const [phone, setPhone] = React.useState('')
  const [password, setPassword] = React.useState('')
  const [errOnlyEnglish, setErrOnlyEnglish] = React.useState('')
  const [showPassword, setShowPassword] = React.useState(false)


  // اضافه کردن Attribute به dom پروژه
  document.documentElement.setAttribute('lang', i18n.language);
  document.documentElement.setAttribute('dir', i18n.dir(i18n.language));


  const onlyEnglish = (e) => {
    var re = new RegExp(/[^A-Za-z0-9!@#\$%\^\&*]/g);
    if (re.test(e.toString())) {
      // alert()
      setErrOnlyEnglish('کیبورد خود را به انگلیسی تغییر دهید')
      return e.toString().replace(re, "")
    } else {
      setErrOnlyEnglish('')
      return e.toString()
    }
  };

  const validationInput = (event) => {
    event.preventDefault();
    !phone ?
       validationMethod('', "phone", t("error.t6"))
       :
       phone?.length !== 11 || !phone.startsWith("09") ?
          validationMethod('', 'phone', t("error.t7"))
          :
          (!divarIncomId && !password) ?
             validationMethod('', "password", t("error.t32"))
             :
             !divarIncomId ? handleLogin() : handleLoginDivar()
  }

  const handleLoginDivar = async () => {
    dispatch(setValidations(null))
    dispatch(setLoading(true))
    let fetch = await fetchData('', 'POST', '/otpLogin', {
         userName: phone,
         affiliateName: sessionStorage.getItem('affiliate')
       },
       "application/x-www-form-urlencoded", '', '', ''
    )


    if (fetch && fetch?.success) {
      showMessageComponent(fetch?.message, 'success')
      navigate({
           pathname: "/auth/verifyCode",
           search: createSearchParams({
             phone: phone,
             state: divarIncomId
           }).toString(),
         },
         {state: location.pathname});

    } else if (fetch && !fetch?.success) {
      showMessageComponent(fetch?.message, 'error')
    } else if (fetch?.status == 500) {
      navigate({
        pathname: "/pageInternalServer",
        search: location?.search
      });
    } else {
      showMessageComponent(fetch?.response?.data?.message, 'error')
    }
    // setResApi(fetch)
    dispatch(setLoading(false))
  }

  const handleLogin = async () => {
    dispatch(setValidations(null))
    dispatch(setLoading(true))
    let fetch = await fetchData('', 'POST', '/login', {
         Username: phone,
         Password: password,
       },
       "application/x-www-form-urlencoded", '', '', ''
    )

    if (fetch && fetch?.StatusCode === 200) {
      await localStorage.setItem('token', fetch?.Token)
      localStorage.setItem('info-user', JSON.stringify({
        "FullName": (fetch?.FirstName || fetch?.LastName) ? fetch?.FirstName + ' ' + fetch?.LastName : null,
        "Email": fetch?.Email,
        "Mobile": fetch?.Username,
        "IsAgent": fetch?.IsAgent,
      }))
      location.pathname !== '/auth/login' ? navigate(location.pathname, {replace: true}) : navigate('/', {replace: true})
      // navigate('/', {replace: true})
      // window.location.reload();
    } else if (fetch && fetch?.StatusCode == 500) {
      navigate({
        pathname: "/pageInternalServer",
        search: location?.search
      });
    } else if (fetch?.ErrorList.length) {
      showMessageComponent(fetch?.ErrorList[0], 'error')
    }
    // setResApi(fetch)
    dispatch(setLoading(fetch?.isLoading))
  }

  return (
     <>
       <div className="authPage">
         <div className="container">
           <div className="row">
             <div className="col-12 col-lg-3 col-xl-4"/>
             <div className="col-12 col-lg-6 col-xl-4">
               <div className="body-page">

                 <div className="logo">
                   <NavLink to='/tracking'>
                     <img src={process.env.REACT_APP_SITE === 'amnito' ? '/amnito.png' : '/Logo.png'} alt="پستِکس"/>
                   </NavLink>
                 </div>

                 <h6 className="description">{t("login.t1")}</h6>
                 <hr/>

                 <form onSubmit={validationInput}>
                   <h6 className="title">{t("login.t2")}</h6>
                   <div className="input">
                     <PhoneIphone/>
                     <input type="text" name="phone" className="numeric" placeholder={t("login.t3")} value={phone}
                            id="phoneNumber" style={handleBorderColor(selector?.public?.validations?.phone)}

                            onChange={e => e.target.value.length <= 11 && setPhone(removeNonNumeric(e.target.value))}/>
                   </div>

                   {selector?.public?.validations?.phone && <p className="error">{selector?.public?.validations?.phone}</p>}

                   <div className="input">
                     <Https/>
                     <input type={!showPassword ? 'password' : 'text'} name="password" placeholder={t("login.t4")} id="password"
                            className="inputPass"
                            value={password}
                            style={handleBorderColor(selector?.public?.validations?.password)}
                            onChange={e => setPassword(onlyEnglish(e.target.value))}/>

                     <button type="button" onClick={() => setShowPassword(!showPassword)}>
                       {
                         showPassword ?
                            <VisibilityOff/>
                            :
                            <Visibility/>
                       }
                     </button>
                   </div>

                   {(selector?.public?.validations?.password || errOnlyEnglish) &&
                   <p className="error">{selector?.public?.validations?.password || errOnlyEnglish}</p>
                   }


                   {/*دکمه فراموشی رمز عبور*/}
                   {/*{*/}
                   {/*  !divarIncomId && */}
                   <div className="forget">
                     <FormGroup>
                       <FormControlLabel control={<Checkbox defaultChecked/>} label={t("login.t5")}/>
                     </FormGroup>

                     <Link to={{pathname: '/auth/newPassword', search: location?.search}} id="newPassword">{t("login.t6")}</Link>
                   </div>
                   {/*}*/}

                   {/*دکمه ورود  کاربر*/}
                   <div className="_btnGroup_blue">
                     <button type="submit" className="btnFill" disabled={selector?.loading?.isLoading} id="validationInput">
                       {
                         selector?.loading?.isLoading ?
                            <Box sx={{display: 'flex'}}>
                              <CircularProgress size={20}/>
                            </Box>
                            :
                            <span>{t("login.t7")}</span>
                       }
                     </button>
                   </div>

                 </form>

                 {/*دکمه رفتن به صفحه ثبت نام*/}
                 {/*{*/}
                 {/*  !divarIncomId &&*/}
                 <div className="route-link">
                   <p>{t("login.t8")}</p>
                   <Link to={{pathname: '/auth/register', search: location?.search}} id="register">{t("login.t9")}</Link>
                 </div>
                 {/*}*/}

                 {/*دکمه برگشت به صفحه اصلی*/}
                 <Link to={{pathname: '/', search: location?.search}} className="goBack" id="home">
                   <p>{t("login.t10")}</p>
                   <KeyboardBackspace/>
                 </Link>

               </div>
             </div>
             <div className="col-12 col-lg-3 col-xl-4"/>
           </div>
         </div>
       </div>
     </>

  )
}
